const sorts = {
  asc: 'asc',
  desc: 'desc',
};

const sortListLabels = {
  order: [
    {
      label: 'Crescente',
      sort: sorts.asc,
    },
    {
      label: 'Decrescente',
      sort: sorts.desc,
    },
  ],
  sort: [
    {
      label: 'A - Z',
      sort: sorts.asc,
    },
    {
      label: 'Z - A',
      sort: sorts.desc,
    },
  ],
  status: [
    {
      label: 'Habilitado',
      sort: sorts.asc,
    },
    {
      label: 'Desabilitado',
      sort: sorts.desc,
    },
  ],
  date: [
    {
      label: 'Mais recente',
      sort: sorts.desc,
    },
    {
      label: 'Mais antiga',
      sort: sorts.asc,
    },
  ],
  history: [
    {
      label: 'Mais recente - mais antiga',
      sort: sorts.desc,
    },
    {
      label: 'Mais antiga - mais recente',
      sort: sorts.asc,
    },
  ],
};

type List = typeof sortListLabels.sort;

export const sortTypes = {
  created: 'created',
  file: 'filename',
  status: 'status',
  name: 'name',
  cpf: 'cpf',
  email: 'email',
  birthdate: 'birthdate',
};

export const beneficiariesSort: { [x: string]: { type: string; labels: List } } = {
  'Data da inclusão': {
    type: sortTypes.created,
    labels: sortListLabels.date,
  },
  'Nome completo': {
    type: sortTypes.name,
    labels: sortListLabels.sort,
  },
  CPF: {
    type: sortTypes.cpf,
    labels: sortListLabels.order,
  },
  'E-mail': {
    type: sortTypes.email,
    labels: sortListLabels.sort,
  },
  'Data de nascimento': {
    type: sortTypes.birthdate,
    labels: sortListLabels.date,
  },
  Status: {
    type: sortTypes.status,
    labels: sortListLabels.status,
  },
};

export const historySort: { type: string; labels: List } = {
  type: sortTypes.created,
  labels: sortListLabels.history,
};
